export default __webpack_public_path__ + "static/logo2-8e671b894089d17eb401c4bdfa83162a.png";